<script setup lang="ts">
import VEmpty from "@magnit/core/src/containers/VEmpty/VEmpty.vue";
import WarningSmileIllustration from "../assets/base-illustration-112-warning-smile.svg";
import { computed } from "vue";
import type { ICatalogEmptyProps } from "../types/VCatalogEmpty.types";

const props = withDefaults(defineProps<ICatalogEmptyProps>(), {
  title: "Ничего не нашлось",
  description: "Посмотрите другие товары или акции",
  icon: WarningSmileIllustration,
});

const emit = defineEmits<{
  "click:primary": [];
  "click:secondary": [];
}>();

const primaryButtonConfig = computed(() => {
  if (props.primaryButton) {
    return props.primaryButton;
  }

  return props.urlPrimaryButton
    ? {
        title: "Все товары",
        url: props.urlPrimaryButton,
      }
    : undefined;
});

const secondaryButtonConfig = computed(() => {
  if (props.secondaryButton) {
    return props.secondaryButton;
  }

  return props.urlSecondaryButton
    ? {
        title: "Все акции",
        url: props.urlSecondaryButton,
      }
    : undefined;
});
</script>

<template>
  <VEmpty
    class="unit-catalog-empty"
    :icon="icon"
    :title="title"
    :description="description"
    :primary-button="primaryButtonConfig"
    :secondary-button="secondaryButtonConfig"
    @click:primary="emit('click:primary')"
    @click:secondary="emit('click:secondary')"
  />
</template>

<style lang="postcss" scoped>
.unit-catalog-empty {
  width: 360px;
  max-width: 100%;
  margin: auto;
}
</style>
